module.exports = __webpack_public_path__ + "static/img/lx_t@2x.a7feea0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/lx_t@2x.png
// module id = wMlS
// module chunks = 1